import { ContractsTypes } from './types';

interface getContractProps {
  page: number;
  companyId?: number | null;
}

export const getContract = ({ page, companyId = null }: getContractProps) => ({
  types: [
    ContractsTypes.GET_CONTRACTS_REQUEST,
    ContractsTypes.GET_CONTRACTS_SUCCESS,
    ContractsTypes.GET_CONTRACTS_FAILURE,
  ],

  promise: (client: any) =>
    client.get(`/contracts/contratos?page=${page}${companyId ? `&companyId=${companyId}` : ''}`),
});

export const SearchContracts = (params: object, page: number) => {
  return {
    types: [
      ContractsTypes.SEARCH_CONTRACTS_REQUEST,
      ContractsTypes.SEARCH_CONTRACTS_SUCCESS,
      ContractsTypes.SEARCH_CONTRACTS_FAILURE,
    ],
    promise: (client: any) =>
      client.get(`/contracts/search?page=${page}`, {
        params,
      }),
  };
};
